import { render, staticRenderFns } from "./SurveyReportsSection.vue?vue&type=template&id=24b3ab84"
import script from "./SurveyReportsSection.vue?vue&type=script&lang=js"
export * from "./SurveyReportsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports